export const oneOfFieldsRequired = {
  bind(el, binding) {
    let elementsIdentifier = binding.value;

    el.setAttribute("ofr", elementsIdentifier);

    // Make this element required.
    el.setAttribute("required", "");

    el.addEventListener("keyup", binding.def.handleKeyup);
  },

  unbind(el, binding) {
    el.removeEventListener("keyup", binding.def.handleKeyup);
  },

  handleKeyup(event) {
    // Get the target input.
    let element = event.target;

    // First, check if this input has value.
    let oneFieldHasValue = element.value.length > 0;

    // Retrieve the group identifier.
    let groupIdentifier = element.getAttribute("ofr");

    // Query for an array of matching elements based on our group identifier.
    let fieldGroup = [
      ...document.querySelectorAll(`[ofr="${groupIdentifier}"]`),
    ];

    // If this input did not have value, check the others in the group.
    if (!oneFieldHasValue) {
      fieldGroup.some(element => {
        if (element.value.length > 0) {
          oneFieldHasValue = true;
          return true;
        }
      });
    }

    // And here we are. If we have at least one field with a value,
    // then remove required. If no fields have any value, then all fields
    // in the group are required.
    fieldGroup.forEach(element => {
      if (oneFieldHasValue) {
        element.removeAttribute("required");
        element.setCustomValidity('');
      } else {
        element.setAttribute("required", "");
      }
    });
  },
};
